export const TIME_FORMAT = 'HH:mm';
export const TIME_SEPARATOR = ':';
export const RANGE_SEPARATOR = '-';
export const MIN_NOT_ALLOWED_HOUR = 24;
